import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { API_URL , API_END_POINT } from '../Utils/Constant';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

const BlogRecommendations = () => {
    const navigate = useNavigate();
    const [relatedBlogs, setRelatedBlogs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const scrollContainer = useRef(null);
    
    const scrollLeft = () => {
        if (scrollContainer.current) {
            const scrollAmount = window.innerWidth < 768 ? 300 : 400;
            scrollContainer.current.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
        }
    };

    const scrollRight = () => {
        if (scrollContainer.current) {
            const scrollAmount = window.innerWidth < 768 ? 300 : 400;
            scrollContainer.current.scrollBy({ left: scrollAmount, behavior: 'smooth' });
        }
    };

    useEffect(() => {
        const fetchRelatedBlogs = async () => {
            try {
                const response = await fetch(`${API_END_POINT}astroblog/`);
                if (!response.ok) {
                    throw new Error(`Failed to fetch blogs: ${response.status}`);
                }
                const data = await response.json();
                // Randomize the blogs before limiting to 10
                const shuffledData = [...data].sort(() => Math.random() - 0.5);
                setRelatedBlogs(shuffledData.slice(0, 10));
                setLoading(false);
            } catch (err) {
                console.error('Error fetching blogs:', err);
                setError('Failed to load related blogs');
                setLoading(false);
            }
        };

        fetchRelatedBlogs();
    }, []);

    if (loading) {
        return (
            <div className="py-8 flex items-center justify-center">
                <div className="text-gray-500 text-xl">Loading...</div>
            </div>
        );
    }

    if (error) {
        return (
            <div className="py-8 flex items-center justify-center">
                <div className="text-red-500 text-xl">Error: {error}</div>
            </div>
        );
    }

    if (relatedBlogs.length === 0) {
        return null; 
    }

    return (
        <div className="max-w-6xl mx-auto px-4 py-8">
            <div className="flex flex-col sm:flex-row justify-between items-center mt-4">
                <h2 className="text-lg sm:text-2xl font-bold pt-3 text-start mb-4">
                    More Blogs You Might Like
                </h2>
                <div className="flex space-x-2">
                    <button
                        onClick={scrollLeft}
                        className="p-2 bg-white rounded-full shadow-md hover:shadow-lg transition-shadow"
                    >
                        <FaChevronLeft className="text-gray-600 hover:text-gray-800" size={20} />
                    </button>
                    <button
                        onClick={scrollRight}
                        className="p-2 bg-white rounded-full shadow-md hover:shadow-lg transition-shadow"
                    >
                        <FaChevronRight className="text-gray-600 hover:text-gray-800" size={20} />
                    </button>
                </div>
            </div>
            {/* Scrollable Blogs Section */}
            <div
                ref={scrollContainer}
                className="mt-2 overflow-x-auto scrollbar-hide snap-x snap-mandatory"
            >
                <div className="flex gap-6 pb-4">
                    {relatedBlogs.map((blogs) => (
                        <div
                            key={blogs._id}
                            className="flex-none w-[280px] sm:w-[320px] lg:w-[350px] bg-white shadow-lg rounded-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 cursor-pointer snap-center"
                            onClick={() => navigate(`/blog/${blogs._id}`)}
                        >
                            <img
                                src={blogs.image || 'https://via.placeholder.com/300x200?text=No+Image'}
                                alt={blogs.title}
                                className="w-full h-48 object-cover"
                            />
                            <div className="p-4">
                                <span className="bg-secondary text-white px-2 py-1 text-sm rounded-full">
                                    {blogs.category}
                                </span>
                                <h3 className="text-lg font-bold text-gray-900 mt-2">{blogs.title}</h3>
                                <p className="text-gray-600 mt-2">
                                    {blogs.content.slice(0, 100)}...
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default BlogRecommendations;